import { GridItem, Flex, Box, Heading } from '@chakra-ui/react';

type Variant = 'default' | 'bold';

export function RowDivider({
  rowIndex,
  variant,
  label,
}: {
  rowIndex: number;
  variant?: Variant;
  label?: string;
}) {
  return (
    <GridItem
      as={Flex}
      gridColumnStart="pa"
      gridRow={rowIndex}
      gridColumnEnd="end"
      justifyContent="center"
    >
      <Box
        h="1px"
        w="full"
        border="1px dashed"
        borderColor="texas.bg.800"
        _light={{ borderColor: 'gray.50' }}
        {...(variant === 'bold'
          ? {
              h: 'auto',
              border: 'none',
              backgroundColor: 'texas.bg.600',
              _light: { backgroundColor: 'gray.100' },
              p: '2',
            }
          : null)}
      >
        {label && <Heading fontSize="md">{label}</Heading>}
      </Box>
    </GridItem>
  );
}
